import variables from '../../styles/exports.module.scss';
import { convertPixelStringToInteger } from '../../utils/helpers';

const PHONE_SIZE = 500;
const TABLET_SIZE = convertPixelStringToInteger(variables.tablet);
const TABLET_LANDSCAPE_SIZE = convertPixelStringToInteger(variables.tabletLandscape);
const DESKTOP_SIZE = convertPixelStringToInteger(variables.desktop);

export const responsiveConfig = {
  tile: [
    {
      breakpoint: DESKTOP_SIZE,
      settings: {
        slidesToShow: 5,
        infinite: true,
      },
    },
    {
      breakpoint: TABLET_LANDSCAPE_SIZE,
      settings: {
        slidesToShow: 4,
        infinite: true,
      },
    },
    {
      breakpoint: TABLET_SIZE,
      settings: {
        slidesToShow: 3,
        infinite: true,
      },
    },
    {
      breakpoint: PHONE_SIZE,
      settings: {
        slidesToShow: 2,
        infinite: true,
      },
    },
  ],
  card: [
    {
      breakpoint: TABLET_LANDSCAPE_SIZE,
      settings: {
        slidesToShow: 2,
        infinite: false,
      },
    },
    {
      breakpoint: TABLET_SIZE,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        infinite: true,
      },
    },
  ],
};
